import React, { Component } from "react";
import { Button } from '@material-ui/core';
import { Image } from '@material-ui/icons';

class UploadImg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };
    }

    onChangeHandler = event => {
        if (event.target.name === "cv") {
            this.props.updateCvFile(event.target.files[0]);
        } else if (event.target.name === "letter") {
            this.props.updateLetterFile(event.target.files[0]);
        }
    }

    render() {
        return (
            <div>
                <input
                    style={{
                        display: "none"
                    }}
                    accept="image/*"
                    id="contained-button-file1"
                    multiple
                    type="file"
                    name="cv"
                    onChange={this.onChangeHandler}
                />
                <label htmlFor="contained-button-file1"
                    style={{
                        marginRight: "30px"
                    }}>
                    <Button
                        variant="contained"
                        color="primary"
                        component="span"
                        endIcon={<Image />}
                    >
                        Choisir un cv
              </Button>
                    {this.props.loaded1 ? this.props.selectCV.name : ""}
                </label>
                <input
                    style={{
                        display: "none"
                    }}
                    accept="image/*"
                    id="contained-button-file2"
                    multiple
                    type="file"
                    name="letter"
                    onChange={this.onChangeHandler}
                />
                <label htmlFor="contained-button-file2">
                    <Button
                        variant="contained"
                        color="primary"
                        component="span"
                        endIcon={<Image />}
                    >
                        lettre de motivation
              </Button>
                    {this.props.loaded2 ? this.props.selectLetter.name : ""}
                </label>
            </div>
        )
    }
}

export default UploadImg;
